import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { numberFormat } from '@fiverr-private/localization';

import * as GroupsSelectors from '../../selectors/groups';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as Translations from '../../providers/i18n';

import PopUp from '../ModalThemePopUp';
import AddPersonalMessage from '../AddPersonalMessage';
import CollaboratorsList from '../CollaboratorsList';
import CreateShareableLink from '../CreateShareableLink';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { CLICKED_INVITE_BUTTON, DISMISS_INVITE_MODAL } from '../../../Utils/mixpanel/mixpanelEvents';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import ConversationWontBeSeenStatus from '../ConversationWontBeSeenStatus';
import { SHARE_REQUEST, collaborationEventBus } from '../../../Utils';
import ShareIcon from './ShareIcon';
import MobileShareIcon from './MobileShareIcon';
import Footer from './Footer';
import InvitePeopleInput from './components/InvitePeopleInput';

import './style.scss';

class InvitePopUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: '',
            filerrIds: [],
            checkBox: false
        };

        this.open = null;

        this.personalMessageChange = this.personalMessageChange.bind(this);
        this.SendToMeChange = this.SendToMeChange.bind(this);
        this.onClickFooterButton = this.onClickFooterButton.bind(this);
        this.onClickCloseButton = this.onClickCloseButton.bind(this);
        this.onShareRequest = this.onShareRequest.bind(this);
        this.onClickInviteButton = this.onClickInviteButton.bind(this);
        this.renderTrigger = this.renderTrigger.bind(this);
    }

    componentDidMount() {
        collaborationEventBus.on(SHARE_REQUEST, this.onShareRequest);
    }

    componentWillUnmount() {
        collaborationEventBus.off(SHARE_REQUEST, this.onShareRequest);
    }

    personalMessageChange(e) {
        this.setState({
            content: e.target.value
        });
    }

    SendToMeChange(e) {
        this.setState({
            checkBox: e.target.checked
        });
    }

    onClickFooterButton() {
        const {
            content,
            checkBox,
            filerrIds
        } = this.state;

        const {
            emails,
            username,
            onShareClick,
            groupId
        } = this.props;

        if (!emails.length) {
            return;
        }

        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_on_done_collaboration_invite_window',
            collaboration: {
                total_collaborators_invite: {
                    added: emails.length,
                    sent: emails.length
                },
                group: {
                    id: groupId,
                    type: 'collaborators'
                }
            }
        });

        onShareClick({
            emails,
            content,
            checkBox,
            username,
            groupId,
            filerrIds
        });

        this.setState({
            content: '',
            filerrIds: []
        });
    }

    onClickCloseButton() {
        this.setState({
            content: '',
            filerrIds: []
        });

        sendMixPanelEvent({
            eventName: DISMISS_INVITE_MODAL
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_on_close_collaboration_invite_window',
            collaboration: {
                total_collaborators_invite: {
                    added: this.props.emails.length,
                    sent: 0
                },
                group: {
                    id: this.props.groupId,
                    type: 'collaborators'
                }
            }
        });
    }

    onShareRequest(source) {
        this.onClickInviteButton(null, source);
    }

    onClickInviteButton(e, source = 'Viewer Header', filerrIds = this.props.filerrIds) {
        if (!this.open) {
            return;
        }

        this.open();
        this.props.deleteAllEmails();

        this.setState({
            filerrIds
        });

        sendMixPanelEvent({
            eventName: CLICKED_INVITE_BUTTON,
            eventData: {
                'Invite Source Component': source
            }
        });

        reportToBigQuery({
            group: 'collaboration',
            type: 'clicked_on_collaboration_invite_button',
            collaboration: {
                group: {
                    id: this.props.groupId,
                    type: 'collaborators'
                }
            }
        });
    }

    renderTrigger({ open }) {
        const {
            trigger: Trigger,
            withoutDefaultTriggerMobileWevBehavior,
            i18n
        } = this.props;
        this.open = open;

        if (Trigger) {
            return <Trigger onClick={this.onClickInviteButton}/>;
        }

        const buttonClasses = classNames('invite-btn', { 'without-mobile-behavior': withoutDefaultTriggerMobileWevBehavior });
        const mobileButtonClasses = classNames('mobile-invite-btn', { 'without-mobile-behavior': withoutDefaultTriggerMobileWevBehavior });

        return (
            <div className="invite-btn-trigger" onClick={this.onClickInviteButton}>
                <Button className={buttonClasses} size="small" color="blue">
                    <ShareIcon/>
                    {i18n.t('attachments_preview.header.share_button')}
                </Button>
                <button className={mobileButtonClasses}>
                    <MobileShareIcon/>
                </button>
            </div>
        );
    }

    render() {
        const {
            emails,
            onChange,
            i18n
        } = this.props;

        const {
            filerrIds
        } = this.state;

        const buttonText = emails.length ? i18n.t('attachments_preview.invite.share') : i18n.t('attachments_preview.invite.done');
        const formattedNumberOfFiles = numberFormat(filerrIds.length, {
            fallbackValue: filerrIds.length
        });
        const headerText = i18n.t('attachments_preview.invite.header', { count: formattedNumberOfFiles });

        return (
            <PopUp name="invite-modal attachments_preview-package order_page_perseus"
                trigger={this.renderTrigger}
                buttonText={buttonText}
                onClickFooterButton={this.onClickFooterButton}
                onClickCloseButton={this.onClickCloseButton}
                header={headerText}
                footer={<Footer/>}>
                {() => (
                    <div className="invite-body">
                        <div className="subtitle">{i18n.t('attachments_preview.invite.subtitle')}</div>
                        <CreateShareableLink/>
                        <hr/>
                        <InvitePeopleInput onChange={onChange} emails={emails}/>
                        <AddPersonalMessage onChange={this.personalMessageChange} content={this.state.content}/>
                        <CollaboratorsList/>
                        <ConversationWontBeSeenStatus/>
                    </div>
                )}
            </PopUp>
        );
    }
}

InvitePopUp.propTypes = {
    emails: PropTypes.array,
    username: PropTypes.string,
    onShareClick: PropTypes.func,
    groupId: PropTypes.string,
    onChange: PropTypes.func,
    deleteAllEmails: PropTypes.func,
    filerrIds: PropTypes.array,
    trigger: PropTypes.any,
    withoutDefaultTriggerMobileWevBehavior: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    username: CollaboratorsSelectors.getCurrentCollaboratorUsername(state),
    groupId: GroupsSelectors.getGroupIdByType(state, 'collaborators'),
    filerrIds: FilerrsSelectors.getFilerrIds(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(InvitePopUp);
